/** @format */

import Postmate from "@regily/regily-postmate";
import {
  isFromRemote,
  inIframe,
  partnerScriptHasConnectQuery,
} from "../utils/browserStructure";
const { publicKey: partnerKey } = require("../partners/partner.module.config");

export const APPLICATION_MODES = Object.freeze({
  STANDARD: "standard", // normal registration flow in partner site
  REMOTE: "remote", // script running in affiliate site with window.regilyRemote present
  PROXY: "proxy", // communication proxy in hidden iframe within partner site
  CRAWLER: "crawler", // settings crawler in hidden iframe within partner site
});

export const IFRAME_MESSAGES = Object.freeze({
  SET_MODE: "setMode",
  MODE_STABLISHED: "modeStablished",
});

export const isConnectPage = () =>
  inIframe() && partnerScriptHasConnectQuery(partnerKey);

// we need to create empty mocks in case the partner try to trigger the regily methods in the connect page
// those will be overwritten by engine if neccessary, in the meantime we retry in case they are defined later.
export const mockRegilyJSApi = () => {
  if (isConnectPage()) {
    window.regily = {
      signUp: {
        open: () => {
          setTimeout(() => {
            window.regily &&
              window.regily.signUp &&
              window.regily.signUp.open();
          }, 1000);
        },
        close: () => {
          setTimeout(() => {
            window.regily &&
              window.regily.signUp &&
              window.regily.signUp.close();
          }, 1000);
        },
      },
    };
  }
};

// we need to check if we have a parent iframe using postmate, and try to get the mode
export const getModeFromParent = () =>
  new Promise((resolve) => {
    const postmateChildHandshake = new Postmate.Model({
      [IFRAME_MESSAGES.SET_MODE]: (mode) => {
        resolve(mode);
      },
    });

    // This will only resolve when handshake` success, so it won't in partner site
    postmateChildHandshake.then((postmateChildConnection) => {
      // As just one single instance of model can be created, and postmate destroy
      // the iframe if closing the connection we are storing the current connection
      // in order to be re-used later by modiying the model instead of creating a new one
      window.regilyRemote = {
        ...(window.regilyRemote || {}),
        postmateChildConnection,
      };
    });
  });

export const getApplicationRunMode = async () => {
  // we add the iframe condition in case partner accidentaly adds the query param in the wrong page
  // this way core will be triggered
  if (isConnectPage()) {
    const parentMode = await getModeFromParent();

    return Object.values(APPLICATION_MODES).includes(parentMode)
      ? parentMode
      : APPLICATION_MODES.STANDARD;
  }

  if (isFromRemote()) {
    return APPLICATION_MODES.REMOTE;
  }

  // if we are not in an iframe means we are in standard mode
  return APPLICATION_MODES.STANDARD;
};

// Will tell the partner-client-template waiting for mode which mode to run, then it will
// wait for MODE_STABLISHED to continue
export const setChildMode = (partnerConnection, onSuccess, mode) => {
  if (partnerConnection && partnerConnection.call) {
    partnerConnection.call(IFRAME_MESSAGES.SET_MODE, mode);
    partnerConnection.on(IFRAME_MESSAGES.MODE_STABLISHED, onSuccess);
  }
};

export const setChildToProxyMode = (partnerConnection, onSuccess) => {
  setChildMode(partnerConnection, onSuccess, APPLICATION_MODES.PROXY);
};

export const setChildToCrawlerMode = (partnerConnection, onSuccess) => {
  setChildMode(partnerConnection, onSuccess, APPLICATION_MODES.CRAWLER);
};

export const confirmModeStablished = (childConnection) => {
  if (childConnection && childConnection.emit) {
    childConnection.emit(IFRAME_MESSAGES.MODE_STABLISHED);
  }
};

// As we already created a first child model to determinate the app mode, we need to extend it
// so we can listen to the calls for this particular mode
export const getExtendedExistingConnection = (connectionModel) => {
  let prevConnection =
    window.regilyRemote && window.regilyRemote.postmateChildConnection;

  if (prevConnection) {
    prevConnection.model = {
      ...prevConnection.model,
      ...connectionModel,
    };
  }

  return prevConnection;
};

// Runs the app mode, extracts the Model handshake and confirms the parent the app is in the correct mode before continuing
export const runModeAndConfirm = async (appModeHandler) => {
  const connection = await appModeHandler();
  confirmModeStablished(connection);
};



// WEBPACK FOOTER //
// ./src/partners/appModeHelpers.js